import { type OfferingProductInterval } from "../../domain/models/offering"
import { type OfferingType } from "../../domain/models/offering-type"

export interface Interval {
  readonly interval: OfferingProductInterval
  readonly frequency: number
}

export class OfferingProductEntity {
  constructor(
    public readonly id: string,
    public readonly price: number,
    public readonly currency_code: string,
    public readonly offering: OfferingType,
    public readonly name: string,
    public readonly billing_interval: Interval,
    public readonly trial_period: Interval,
    public readonly price_type: string
  ) {}
}

export class OfferingItemEntity {
  constructor(
    public readonly prices: OfferingProductEntity[],
    public readonly offering: OfferingType
  ) {}
}

export class OfferingEntity {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly type: string,
    public readonly offerings: OfferingItemEntity[]
  ) {}
}
